<template>
	<div class="risk-level">
		<BadgeLabel v-if="showLabel" :text="labelText" />
		<BaseBadge :badge-class="badgeColor">
			<div class="spacer">
				<span>{{ badgeText }}</span>
				<button
						v-if="showEditButton"
						data-test-id="edit-risk-level"
						class="edit-button"
						type="button"
						@click="$emit('edit')"
				>
					<span class="sr-only">Risicoklasse aanpassen</span>
					<IconSvg icon="edit" />
				</button>
			</div>
		</BaseBadge>
	</div>
</template>

<script setup lang="ts">
	import {computed} from 'vue';
	import type {PropType} from 'vue';
	import {getRiskLevel, getRiskLevelBadgeColor, getRiskLevelText} from '~/lib/riskHelper';
	import type {RiskLevel, RiskDeviation} from '~/lib/types/riskTypes';
	import BaseBadge from '~/components/generic/badge/BaseBadge.vue';
	import IconSvg from '~/components/generic/IconSvg.vue';
	import BadgeLabel from '~/components/generic/badge/BadgeLabel.vue';

	const props = defineProps({
		risk: {
			type: Object as PropType<{
				level: RiskLevel;
				levelDeviation?: RiskDeviation;
			}>,
			required: true
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		showEditButton: {
			type: Boolean,
			default: false
		}
	});

	defineEmits<{
		// eslint-disable-next-line no-unused-vars
		(e: 'edit'): void
	}>();

	const riskLevel = computed(() => getRiskLevel(props.risk));
	const badgeText = computed(() => getRiskLevelText(riskLevel.value));
	const badgeColor = computed(() => getRiskLevelBadgeColor(riskLevel.value));

	const labelText = computed(() => {
		if (props.risk.levelDeviation) {
			return 'Aangepaste risicoklasse';
		}

		return 'Risicoklasse';
	});
</script>

<style scoped>
	.risk-level {
		--badge-padding-x: 1rem;
	}

	.spacer {
		display: flex;
		min-width: 58px;
	}

	.edit-button {
		cursor: pointer;
		border: none;
		background: none;
		flex: 0 0 auto;
		padding: 4px 6px 4px 6px;
		margin: -4px -12px -4px auto;
		color: inherit;
	}

	.edit-button:deep(svg) {
		--icon-size: 14px;
	}
</style>
